import { Button, Modal, useSnackbar } from '@tecsinapse/cortex-react'
import { Trans } from '@lingui/react/macro'
import React from 'react'
import { Funcionalidade, Produto } from '@/core/types/graphql'
import { UsuarioPermissaoItem } from '../columns-permissao'
import { useFormContext, useWatch } from 'react-hook-form'
import { t } from '@lingui/core/macro'
import { EventGoal, EventOrigin, logEvent } from '@/core/analytics'
import { AnalyticsEvents } from '@/core/analytics/analytics-eventes-enum'

const clonarTiposAcessoEFuncionalidades = ({
  values,
  selectedRow,
  produtos,
  setValue
}: any) => {
  const novasPemissoes = JSON.parse(JSON.stringify(values.produtos)) ?? {}

  produtos.forEach((produto: Produto) => {
    const idProduto = produto.id

    if (!novasPemissoes[idProduto]) {
      novasPemissoes[idProduto] = {}
    }

    const permisProduto = novasPemissoes[idProduto]

    permisProduto.idsTiposAcesso = []
    permisProduto.funcionalidades = []

    const tipoAcesProduto = selectedRow.tiposAcessoByProduto[idProduto]

    if (tipoAcesProduto) {
      permisProduto.idsTiposAcesso = [...tipoAcesProduto.tiposAcesso].map(
        ({ id, nome }) => ({
          label: nome,
          value: id
        })
      )
      permisProduto.funcionalidades = (
        selectedRow.funcionalidades as Funcionalidade[]
      )
        .filter(f => f.produto.id === idProduto)
        .map(({ id }) => id)
    }
  })

  setValue('produtos', novasPemissoes, { shouldDirty: true })
  logEvent({
    name: AnalyticsEvents.CLONAR_PERMISSOES_CONCLUIDO,
    params: {
      origin: EventOrigin.button,
      goal: EventGoal.success
    }
  })
}

export type CustomProps = {
  open: boolean
  produtos: Produto[]
}
export interface ModalConfirmacaoProps {
  selectedRow?: UsuarioPermissaoItem
  isConfirmacaoOpen: boolean
  handleCloseConfirmacao: () => void
  onOpenTable: () => void
  customProps: CustomProps
}

export const ModalConfirmacao = (props: ModalConfirmacaoProps) => {
  const {
    selectedRow,
    isConfirmacaoOpen,
    handleCloseConfirmacao,
    onOpenTable,
    customProps
  } = props
  const { snackbar } = useSnackbar()
  const values = useWatch()
  const { setValue } = useFormContext()

  const onClose = () => {
    handleCloseConfirmacao()
    onOpenTable()
  }

  const { nome } = values
  const { produtos } = customProps

  return (
    <Modal
      open={isConfirmacaoOpen}
      onClose={onClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <div className='flex flex-col space-y-mega'>
        <p className={'font-bold text-center'}>
          <Trans>
            Deseja clonar as permissões do usuário {selectedRow?.nome}?
          </Trans>
        </p>
        <p className={'mb-giga'}>
          <Trans>
            As permissões do usuário{' '}
            <span className={'font-bold'}>{nome} </span>
            serão substituídas pelas permissões do usuário{' '}
            <span className={'font-bold'}>{selectedRow?.nome}</span>.
            <p>
              Você ainda poderá editá-las após a confirmação. Deseja continuar?
            </p>
          </Trans>
        </p>
        <div
          className={'flex items-center justify-between flex-row space-x-deca '}
        >
          <Button
            variants={{ variant: 'outline', className: 'w-full' }}
            type={'button'}
            onClick={onClose}
          >
            <Trans>Cancelar</Trans>
          </Button>
          <Button
            variants={{ className: 'w-full' }}
            type={'button'}
            onClick={() => {
              logEvent({
                name: AnalyticsEvents.CLONAR_PERMISSOES,
                params: {
                  origin: EventOrigin.button,
                  goal: EventGoal.submit
                }
              })

              clonarTiposAcessoEFuncionalidades({
                selectedRow,
                values,
                produtos,
                setValue
              })
              handleCloseConfirmacao()
              snackbar.show('success', t`Permissões clonadas com sucesso!`)
            }}
          >
            <Trans>Confirmar</Trans>
          </Button>
        </div>
      </div>
    </Modal>
  )
}
